import { render } from "./ReportLogs.vue?vue&type=template&id=7bc8dc48"
import script from "./ReportLogs.vue?vue&type=script&lang=js"
export * from "./ReportLogs.vue?vue&type=script&lang=js"

import "./ReportLogs.vue?vue&type=style&index=0&id=7bc8dc48&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__